import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_milspec: FaireProductEntity = {
  token: "apparel-socks-milspec",
  type: "product",
  name: "The Mil-Spec",
  brandName: "American Trench",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/17638a5a20ea3da4173ea66349b3ff3457c792674c449d18ba3515793a3089ab.jpeg",
  priceDollars: 7.5,
  msrpDollars: 15,
  freeShipping: true,
  weight: 0.2,
  dimensions: {
    width: 4,
    height: 2,
    depth: 1,
  },
  description:
    "Military-inspired over-the-calf sock. Durable cotton with reinforced heel and toe.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "military", "crew"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
